export const DEFAULT_BOX = {
    name: { x: 50, y: 16.2, w: 72, h: 6.8, weight: 800, color: "#FFFFFF" },
    code: { x: 50, y: 24, w: 60, h: 5.0, weight: 700, color: "#FFFFFF" },
    jobTitle: { x: 50, y: 40, w: 60, h: 5.0, weight: 700, color: "#FFFFFF" },
    info: { x: 50, y: 33.4, w: 66, h: 5.6, weight: 800, color: "#F3B5C8" },
    amount: { x: 50, y: 94.6, w: 62, h: 8.0, weight: 800, color: "#1F2A7C" },
    transaction: { x: 50, y: 80, w: 66, h: 5.6, weight: 700, color: "#FFFFFF" },
    avatar: { cx: 50, cy: 54, d: 44 },
};